import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const archiveProjectFeatureGateModalEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-archive-project-feature-gate-modal" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
